import React, { ComponentProps } from 'react'

import { BuyButton as BuyButtonBase } from '@Components/BuyButton/button'
import { BuyPrompts as BuyPromptsBase } from '@Components/BuyButton/prompts'
import { BuyRoot as BuyRootBase } from '@Components/BuyButton/root'

export const BuyButton = ({
  milestoneID,
  onPromptChange,
  onSuccess,
  preventDefault,
  productID,
  products,
  quantity,
  sourceID,
  stopPropagation,
  useCache,
  variantID,
  withoutSuccessPrompt,
  ...buttonProps
}: Omit<ComponentProps<typeof BuyRootBase>, 'children'> & ComponentProps<typeof BuyButtonBase>) => (
  <BuyRootBase
    milestoneID={milestoneID}
    onPromptChange={onPromptChange}
    onSuccess={onSuccess}
    preventDefault={preventDefault}
    productID={productID}
    products={products}
    quantity={quantity}
    sourceID={sourceID}
    stopPropagation={stopPropagation}
    useCache={useCache}
    variantID={variantID}
    withoutSuccessPrompt={withoutSuccessPrompt}
  >
    <BuyButtonBase {...buttonProps} />
    <BuyPromptsBase />
  </BuyRootBase>
)

export const Buy = {
  Button: BuyButtonBase,
  Prompts: BuyPromptsBase,
  Root: BuyRootBase,
}
